<template>
    <div>


    <div class="nav">
              <ul class="list3">
                  <li><el-button size="large" color="#e8f2ff"  tag="a" href="/"><el-icon><House /></el-icon>首页</el-button></li>
                  <li v-if="bookdetail.CATEGORY == '高考资料'"><el-button  size="large" color="#5cbaf6" type="primary" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/gkzl"><el-icon style="color: #ffffff;"><Coin /></el-icon>高考资料</el-button></li>
                  <li v-if="bookdetail.CATEGORY != '高考资料'"><el-button  size="large" color="#e8f2ff" tag="a" href="/gkzl"><el-icon><Coin /></el-icon>高考资料</el-button></li>
                  <li v-if="bookdetail.CATEGORY == '自考教材'"><el-button size="large" type="primary"  color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/zkjc"><el-icon style="color: #ffffff;"><Reading /></el-icon>自考教材</el-button></li>
                  <li v-if="bookdetail.CATEGORY != '自考教材'"><el-button  size="large" color="#e8f2ff" tag="a" href="/zkjc"><el-icon><Reading /></el-icon>自考教材</el-button></li>
                  <li v-if="bookdetail.CATEGORY == '书法教材'"><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/sfjc"><el-icon style="color: #ffffff;"><EditPen /></el-icon>书法教材</el-button></li>
                  <li v-if="bookdetail.CATEGORY != '书法教材'"><el-button size="large" color="#e8f2ff"  tag="a" href="/sfjc"><el-icon><EditPen /></el-icon>书法教材</el-button></li>
                  <li v-if="bookdetail.CATEGORY == '报刊杂志'"><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/bkzz"><el-icon style="color: #ffffff;"><DocumentCopy /></el-icon>报刊杂志</el-button></li>
                  <li v-if="bookdetail.CATEGORY != '报刊杂志'"><el-button size="large" color="#e8f2ff" tag="a" href="/bkzz"><el-icon><DocumentCopy /></el-icon>报刊杂志</el-button></li>
                  <li v-if="bookdetail.CATEGORY == '特价图书'"><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/tjts"><el-icon style="color: #ffffff;"><CollectionTag /></el-icon>特价图书</el-button></li>
                  <li v-if="bookdetail.CATEGORY != '特价图书'"><el-button size="large" color="#e8f2ff" tag="a" href="/tjts"><el-icon><CollectionTag /></el-icon>特价图书</el-button></li>
                  <li v-if="bookdetail.CATEGORY == '成绩证书'"><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/cjzs"><el-icon style="color: #ffffff;"><Notebook /></el-icon>成绩证书</el-button></li>
                  <li v-if="bookdetail.CATEGORY != '成绩证书'"><el-button size="large" color="#e8f2ff" tag="a" href="/cjzs"><el-icon><Notebook /></el-icon>成绩证书</el-button></li>
                  <li v-if="bookdetail.CATEGORY == '其他'"><el-button size="large"  type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/others"><el-icon style="color: #ffffff;"><Menu /></el-icon>其他</el-button></li>
                  <li v-if="bookdetail.CATEGORY != '其他'"><el-button size="large" color="#e8f2ff" tag="a" href="/others"><el-icon><Menu /></el-icon>其他</el-button></li>
              </ul>
          </div>
          <div class="Breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item>{{ bookdetail.CATEGORY }}</el-breadcrumb-item>
                <el-breadcrumb-item>书籍详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div>
            <div class="img">
                <el-carousel motion-blur height="500px">
                    <el-carousel-item v-for="item in bookdetail.IMG_COVER" :key="item">
                        <el-image :src="item" style="width: 320px; height: 440px; margin-top: 30px; " />
                    </el-carousel-item>
                </el-carousel>
                
            </div>
            <div class="detail">
                <p class="bookname">{{ bookdetail.NAME }}</p>
                <p class="bookintroduction">{{ bookdetail.INTRODUCTION }}</p>
                <p v-if="bookdetail.COURSE_CODE" class="code">课程代码：{{ bookdetail.COURSE_CODE }}</p>
                <p class="price">价格：<span>￥</span><span>{{ bookdetail.PRICE }}</span></p>
                <el-link :underline="false" :href="'/bookcode/'+this.id"><el-button   size="large" color="#c93639">立即购买</el-button></el-link>
            </div>
          </div>
          <div class="tags">
            <div style="width: 7px;height: 7px;background-color: orange;"></div>
            <div style="width: 7px;height: 33px;background-color:#49aef1 ; margin-top: 6px;"></div>
            <div class="tag1">详情参数</div>
            <div class="triangle"></div>
            <div class="tag"></div>
            <div class="more">MORE+</div>
            <hr>
           </div>
           <div class="argument">
            <span>作者：{{ bookdetail.AUTHOR }}</span>
            <span>出版社：{{ bookdetail.PRESS }}</span>
            <span>ISBN书号：{{ bookdetail.ISBN }}</span>
           </div>
           <div class="bookcatalog">
            <el-image v-if="bookdetail.IMG_COVER" class="img1" :src="bookdetail.IMG_COVER[0]" />
            <ul class="details">
                <li><div>名&nbsp;&nbsp; 称</div> {{ bookdetail.NAME }}</li><hr>
                <li><div>作&nbsp;&nbsp; 者</div> {{ bookdetail.AUTHOR }}</li><hr>
                <li><div>定&nbsp;&nbsp; 价</div> {{ bookdetail.PRICE }} &nbsp;元</li><hr>
                <li v-if="bookdetail.SIZE != 0"><div>尺 &nbsp;&nbsp;寸</div> 约&nbsp;&nbsp;{{ bookdetail.SIZE }}</li><hr v-if="bookdetail.SIZE != 0">
                <li v-if="bookdetail.PAGES != 0"><div>页 &nbsp;&nbsp;数</div> 约&nbsp;&nbsp;{{ bookdetail.PAGES }}&nbsp;&nbsp;页</li><hr v-if="bookdetail.PAGES != 0">
                <li><div>I S B N</div> {{ bookdetail.ISBN }}</li><hr>
                <li><div>版 &nbsp;&nbsp;次</div> {{ bookdetail.VERSION }}</li><hr>
                <li><div>出版社</div> {{ bookdetail.PRESS }}</li><hr>
            </ul>
            <div class="title">图书目录</div>
            <el-image v-for="item in bookdetail.IMG_DIRECTORY" :key="item"   :src="item" class="img2" />
           </div>
        </div>
</template>

<script>

export default {
    name: "BookDetail",
    props: {
        id: String
    },
    methods: { 
        getBookDetail(){
            this.$axios.post('/api/Book/BookDetail', {
                ID: this.id
            }).then(res=>{
                //将返回数据中以逗号为分隔的IMG_COVER转化为数组
                res.data.IMG_COVER = res.data.IMG_COVER.split(',');
                //将返回数据中以逗号为分隔的IMG_DIRECTORY转化为数组
                res.data.IMG_DIRECTORY = res.data.IMG_DIRECTORY.split(',');
                //清除数组中的空元素
                res.data.IMG_COVER = res.data.IMG_COVER.filter(item => item);
                res.data.IMG_DIRECTORY = res.data.IMG_DIRECTORY.filter(item => item);
                if(res.data.ISBN == 0){
                    res.data.ISBN = '暂无';
                }
                if (res.data.CATEGORY === '成绩证书') {
                    this.$router.replace('/cjzsdetail/' + this.id);
                    return;
                }
                console.log(res.data);
                this.bookdetail = res.data;
            })
        }
    },
    data(){
        return{
            bookdetail:[],
        }
    },
    created(){
        this.getBookDetail();
    }
}
</script>

<style scoped>
.img2{
    width: 890px;
    height: 100%;
    margin-top: 50px;
}
.title{
    width: 890px;
    height: 100px;
    background-color: #c00202;
    float: left;
    margin-left: 200px;
    margin-top: 80px;
    border-radius: 90px;
    color: #ffffff;
    font-size: 70px;
}
.details hr{
    display: inline-block;
    width: 420px;
    margin-left: 0px;
    border: none;
    height: 1px;
    background: #000;
}
.details li div{
    display: inline-block;
    width: 90px;
    text-align: center;
    margin-right: 20px;
    font-size: 22px;
    font-weight: 500;
    height: 32px;
    background-color: #c00202;
    color: #ffffff;
}
.details li{
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    text-align: left;
    color: #010101;
}
.details{
    width: 420px;
    height: 500px;
    float: left;
    margin-top: 80px;
    margin-left: 50px;
    list-style-type: none;
}
.img1{
    width: 420px;
    height: 500px;
    margin-top: 80px;
    margin-left: 200px;
    float: left;
}
.bookcatalog{
    width: 1300px;
    border-radius: 6px;
    border: #f0efef solid 1px;
    float: left;
    margin-left: 250px;
    margin-top: 20px;
}
/* 弹窗 (background) */
.modal {
    display: none; /* 默认隐藏 */
    position: fixed; 
    z-index: 1; 
    padding-top: 400px; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: auto; 
    background-color: rgb(0,0,0); 
    background-color: rgba(0,0,0,0.4);
}

/* 弹窗内容 */
.modal-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    border-radius: 8px;
    border: 1px solid #888;
    width: 250px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
}

/* 添加动画 */
@-webkit-keyframes animatetop {
    from {top:-300px; opacity:0} 
    to {top:0; opacity:1}
}

@keyframes animatetop {
    from {top:-300px; opacity:0}
    to {top:0; opacity:1}
}

/* 关闭按钮 */
.close .el-icon {
    color: #ffffff;
    font-weight: bold;
    margin-top: 20px;
    margin-left: 90px;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

.modal-header {
    padding-top: 10px;
    height: 50px;
    background: linear-gradient(to top, #48a9f3,#6bc8f9);
    color: white;
    border-radius: 8px 8px 0 0;
}

.modal-body {padding: 2px 16px;}

.modal-footer {
    padding: 2px 16px;
    float: left;
    color: white;
}
.argument span:nth-child(3){
    position: absolute;
}
.argument span:nth-child(2){
    position: absolute;
    margin-left: -350px;
}
.argument span{
    font-size: 16px;
    font-weight: bold;
    margin-left: 20px;
    margin-top: 20px;
    color: #515c68;
    float: left;
}
.argument{
    width: 1300px;
    border-radius: 6px;
    height: 60px;
    margin-left: 250px;
    margin-top: 20px;
    background: linear-gradient(to bottom, #fafafa,#f6f7f7);
    border: #f0efef solid 1px;
    float: left;
}
.more{
    float: right;
    margin-right: 300px;
    margin-top: -29px;
    color: #79838a;
}
hr{
    width: 1160px;
    margin-left: 140px;
    margin-top: -2px;
    border: 1px solid #efefef;
}
.tags{
    width: 1600px;
    float: left;
    height: 46px;
    margin-left: 250px;
    margin-top: 10px;
}
.tag1{
    font-size: 20px;
    color: #ffffff;
    width: 110px;
    height: 46px;
    margin-top: -46px;
    margin-left: 15px;
    position: relative;
    padding-top: 10px;
    background: linear-gradient(to top, #47a8f3,#6ac7f8);
}
.triangle{
    width: 25px;
    height: 46px;                                       
    margin-left: 125px;
    clip-path: polygon(0 0, 0 100%, 50% 100%);
    margin-top: -46px;
    background: linear-gradient(to top, #47a8f3,#6ac7f8)
}
.tag{
    width: 800px;
    float: left;
    height: 26px;
    margin-left: 138px;
    background-color: #efefef;
    margin-top: -35px;
    background: repeating-linear-gradient(145deg, white, white 2px, #efefef 2px, #efefef 4px) ;
    mask-image: linear-gradient(to left, transparent 0%, black 60%);
    transform: skew(19deg);
}
.detail .el-button{
    color: #ffffff;
    margin-top: 80px;
    width: 150px;
    height: 50px;
    font-size: 17px;
    border-radius: 7px;
}

.price span:nth-child(2){
    font-size: 30px;
    font-weight: bold;
    color: #d41e26;
}
.price span:nth-child(1){
    font-size: 17px;
    font-weight: bold;
    color: #d41e26;
}
.price{
    font-size: 17px;
    margin-top: 80px;
    font-weight: 550;
    color: #7d878e;
}
.code{
    font-size: 17px;
    margin-top: 60px;
    font-weight: 550;
    color: #000000;
}
.bookintroduction{
    font-size: 15px;
    margin-top: 60px;
    line-height: 30px;
    font-weight: 550;
    color: #8d959b;
}
.bookname{
    font-size: 20px;
    margin-top: 10px;
    font-weight: bold;
    color: #4f5b66;
}
.detail{
    width: 800px;
    height: 500px;
    margin-top: 25px;
    margin-left: 60px;
    text-align: left;
    float: left;
}
.img{
    width: 420px;
    height: 500px;
    margin-top: 30px;
    margin-left: 250px;
    border: #c3d1db solid 1px;
    float: left;
}
.el-breadcrumb{
    margin-top: 20px;
    margin-left: 270px;
    height: 60px;
    font-size: 16px;
    color: #c1c6c9;
    float: left;
}
.Breadcrumb{
    width: 1903px;
    height: 60px;
    background: #f5f6f6;
    margin-top: 10px;
    margin-left: -20px;
    float: left;
}
  .el-icon{
      font-size: 25px;
      margin-right: 10px;
      color: #49aef1;
  }
  
  .list3 .el-button{
      width: 161px;
      height: 46px;
      font-size: 16px;
      border-radius: 7px;
      color: #000;
      margin-top: 1px;
      padding-left: 10px;
      background: linear-gradient(to top, #deedff,#f3f8ff);
  }
  .list3 {
      list-style-type: none;
      float: left;
      margin-left: 240px;
      margin-top: 5px;
      height: 60px;
  }
  
  .list3 li {
      float: left;
      font-size: 20px;
      margin-left: 20px;
      width: 165px;
      height: 50px;
      font-weight: bold;
      border-radius: 7px;
      display: block;
      color: #49aef1;
      border: #c3d1db solid 1px;
  }
  .list3 a{
      text-decoration: none;
      color: #49aef1;
  }
 .nav .el-button:hover {
      background: linear-gradient(to top, #47a8f3,#6ac7f8);
      color: #ffffff;
  }
  
 .nav .el-button:hover .el-icon {
      color: #ffffff;
  }
</style>